import { render, staticRenderFns } from "./AccountManage.vue?vue&type=template&id=1a242c4c&"
import script from "./AccountManage.vue?vue&type=script&lang=ts&"
export * from "./AccountManage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports